import React from "react";
import { createPortal } from "react-dom";
import { Edit, FileText, Share2, Trash2, Users, X } from "lucide-react";
import { ICONS } from "./constants";

export default function TeacherMinuteDetailModal({
  handleDeleteMinute,
  handleMinuteDetailMouseDown,
  handleShareMinute,
  minuteDetailModalPos,
  onClose,
  onEdit,
  viewingMinute,
}) {
  if (!viewingMinute) return null;

  return createPortal(
    <div className="fixed inset-0 bg-transparent flex items-center justify-center z-[9990] p-4 pointer-events-none" onClick={onClose}>
      <div
        className="bg-white rounded-[2.5rem] p-0 w-full max-w-lg shadow-2xl relative max-h-[90vh] overflow-hidden border border-white/50 flex flex-col pointer-events-auto"
        onClick={(e) => e.stopPropagation()}
        style={{ transform: `translate(${minuteDetailModalPos.x}px, ${minuteDetailModalPos.y}px)` }}
      >
        <div
          className="flex justify-between items-center px-6 py-5 border-b border-gray-100 bg-white cursor-move z-10"
          onMouseDown={handleMinuteDetailMouseDown}
        >
          <h3 className="text-xl font-black text-[#2C3E30] flex items-center gap-2 font-do-hyeon">
            <img src={ICONS.notebook} width={24} alt="icon" /> 회의록 상세
          </h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 bg-gray-50 hover:bg-gray-100 p-2 rounded-full transition-colors"><X size={20} /></button>
        </div>

        <div className="flex-1 overflow-y-auto custom-scrollbar p-6">
          <div className="flex items-center gap-4 mb-6">
            <div>
              <span className="text-xs font-bold text-[#354F38] bg-[#F0F0EB] px-3 py-1 rounded-full mb-1 inline-block border border-[#354F38]/10">{viewingMinute.date}</span>
              <h3 className="text-2xl font-black text-gray-900 leading-tight">{viewingMinute.title}</h3>
            </div>
          </div>

          <div className="space-y-6">
            <div className="bg-white p-6 rounded-3xl border border-gray-100 shadow-sm">
              <h4 className="text-xs font-bold text-gray-400 mb-3 flex items-center gap-1 uppercase tracking-wider"><Users size={12} /> 참석자 명단</h4>
              <div className="flex flex-wrap gap-2">
                {viewingMinute.attendees ? viewingMinute.attendees.split(",").map((person, i) => (
                  <span key={i} className="bg-gray-50 px-3 py-1.5 rounded-xl text-sm font-bold text-gray-700 border border-gray-200">{person.trim()}</span>
                )) : <span className="text-gray-400 text-sm">기록 없음</span>}
              </div>
            </div>
            <div>
              <h4 className="text-xs font-bold text-gray-400 mb-3 flex items-center gap-1 uppercase tracking-wider"><FileText size={12} /> 회의 내용</h4>
              <div className="bg-[#F9F9F8] p-6 rounded-3xl text-gray-700 leading-relaxed whitespace-pre-wrap text-sm min-h-[150px] border border-gray-100/50 shadow-inner">{viewingMinute.content}</div>
            </div>
          </div>

          <div className="flex justify-center gap-6 mt-8 pt-6 border-t border-gray-100">
            <button onClick={() => handleShareMinute(viewingMinute)} className="flex flex-col items-center gap-1 text-gray-400 hover:text-gray-800 transition-colors group">
              <div className="p-3 rounded-full bg-gray-50 group-hover:bg-gray-100 transition-colors">
                <Share2 size={20} />
              </div>
              <span className="text-xs font-medium">공유</span>
            </button>

            <button onClick={() => onEdit(viewingMinute)} className="flex flex-col items-center gap-1 text-gray-400 hover:text-blue-600 transition-colors group">
              <div className="p-3 rounded-full bg-gray-50 group-hover:bg-blue-50 transition-colors">
                <Edit size={20} />
              </div>
              <span className="text-xs font-medium">수정</span>
            </button>
            <button onClick={() => handleDeleteMinute(viewingMinute.id)} className="flex flex-col items-center gap-1 text-gray-400 hover:text-rose-600 transition-colors group">
              <div className="p-3 rounded-full bg-gray-50 group-hover:bg-rose-50 transition-colors">
                <Trash2 size={20} />
              </div>
              <span className="text-xs font-medium">삭제</span>
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}
